import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    Editing
} from 'devextreme-react/data-grid';
import * as AppActions from '../../actions/AppActions';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { ToastType } from "../../constants/Constants";
import { showToast, parseDate, hasRole,parseApiDate } from "../../utils/Utils";
import './SgkIslemleri.scss';
import CustomStore from 'devextreme/data/custom_store';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import Request from "../../components/api/Request";
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';
import DateBox from 'devextreme-react/date-box';
import Box, {
    Item
} from 'devextreme-react/box';
import TagBox from 'devextreme-react/tag-box'; 

const SgkIslemEkleForm = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            listele: hasRole("sgkIslemleri|sgkDonemIslemleri|listele"),
            sil: hasRole("sgkIslemleri|sgkDonemIslemleri|sil"),
            ekle: hasRole("sgkIslemleri|sgkDonemIslemleri|ekle")
        });

    //const [sgkIslemData, setSgkIslemData] = useState({});

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [treeBoxDonemValue, setTreeBoxDonemValue] = useState([]);
    const [treeDataDonemSource, setTreeDataDonemSource] = useState([]);

    const [dateData, setDateData] = useState(null);

    const [storeIslem, setStoreIslem] = useState([]);

    const [valueIslem, setValueIslem] = useState([]);

    const [sgkIslemEkleDetay, setSgkIslemEkleDetay] = useState([]);
    const dataSource = new DataSource({
        store: new ArrayStore({
            data: sgkIslemEkleDetay,
            key: 'id'
        })
    });

    useEffect(() => {
        setDateData(new Date());
        domainListYukle();
        donemListYukle();
        islemTuruListYukle();
    }, [])


    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if (d.tarih.getTime() < simdi.getTime()) {
                            datas.push(d);
                        }
                    });
                    // datas.sort((a,b) =>
                    //     a.tarih.getTime() - b.tarih.getTime()
                    // ).reverse();
                    // debugger;
                    let yils = [];
                    let yilDatas = [];
                    datas.map(d => {
                        let parentYil = parseInt(d.donem.substring(0, 4)) * -1;
                        d.parentid = parentYil;
                        if (yils.indexOf(parentYil) == -1) {
                            yils.push(parentYil);
                            let donemTmp = (parentYil * -1).toString();


                            yilDatas.push({ donem: donemTmp, id: parentYil, parentid: 0 });
                        }
                    });
                    yilDatas.map(d => {
                        datas.push(d);
                    });

                    setTreeDataDonemSource(datas);
                } else {
                    return []
                }
            });
    }

    const islemTuruListYukle = () => {

        const request = new Request("/tesvikIslem/getTesvikIslemTuruList", "GET");

        request.run()
            .then(response => {

                if (response.data) {
                    setStoreIslem(response.data.data);
                } else {
                    return []

                }
            });
    }

    let dataGrid = null;
    let treeView = null;
    let treeViewDonem = null;

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                key="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const syncTreeViewDonemSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeViewDonem && treeViewDonem.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxDonemValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxDonemValue([]);
            } else {
                setTreeBoxDonemValue(e.value);
            }
        }
    }

    const treeViewDonem_itemSelectionChanged = (e) => {
        setTreeBoxDonemValue(e.component.getSelectedNodeKeys());
    }

    const treeViewDonemRender = () => {
        return (
            <TreeView dataSource={treeDataDonemSource}
                ref={(ref) => treeViewDonem = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentid"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="donem"
                selectByClick={true}
                onContentReady={syncTreeViewDonemSelection}
                onItemSelectionChanged={treeViewDonem_itemSelectionChanged}
            />
        );
    }

    const tagBox_itemSelectionChanged = (e) => {
        setValueIslem(e.component._getValue());
    }

    const onDateValueChanged = (e) => {
        setDateData(e.value);
    }



    function kaydet(e) {
 

        let array =[]
      

        sgkIslemEkleDetay.map(detay => {
            let data = {};
            data.baslatmaTarihi =parseApiDate(detay.baslatmaTarihi);
            data.domain ={ id: detay.domain.id};
            if(detay.donem != null){
                data.donem ={ id: detay.donem.id};
            }
            data.tesvikIslemTuru ={ id: detay.tesvikIslemTuru.id};
            data.sira = detay.sira;
            data.islemDurumu = 0;
            array.push(data); 
        });

        let method = "POST"
        let url = "/tesvikIslem/saveList";
       
        const request = new Request(url, method, array);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
          
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });
    }

    const ekle = () => {


        if (treeBoxValue == null || treeBoxValue.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }

        if (treeBoxDonemValue == null || treeBoxDonemValue.length == 0) {
            showToast('Dönem Seçiniz', ToastType.ERROR, 500);
            return;
        }

        if (dateData == null) {
            showToast('Tarih Seçiniz', ToastType.ERROR, 500);
            return;
        }

        if (valueIslem == null || valueIslem.length == 0) {
            showToast('İşlem Seçiniz', ToastType.ERROR, 500);
            return;
        }
        let array = []

        let i = 0;
        let sira = 0; 
 
        const request = new Request("/tesvikIslem/getMaxSira", "GET"); 
        request.run()
            .then(response => {
                 sira =response.data.data;

                 treeBoxValue.map(domainId => {
                    sira++;
                    let domain = treeDataSource.find(domain => domain.id === domainId);
                    if(domain.sicilNo != null && domain.sicilNo != ""){
                        treeBoxDonemValue.map(donemId => {
                            valueIslem.map(islemId => {
                                let tesvikIslemTuru = storeIslem.find(islem => islem.id === islemId);
                                
                                
                                if (tesvikIslemTuru.donemZorunlu) {
                                    let donem = treeDataDonemSource.find(donem => donem.id === donemId);
                                    if(donem.parentid != null && donem.parentid != 0){
                                        i++;
                                        let data = {};
                                        data.id = i;
                                        data.baslatmaTarihi = dateData;
                                        data.domain = domain;
                                        data.donem = donem;
                                        data.tesvikIslemTuru = tesvikIslemTuru;
                                        data.sira = sira;
                                        data.islemDurumu = 0;
                                        array.push(data);
                                    }                            
                                }
                            });
                        });
            
            
                        valueIslem.map(islemId => {
                            let tesvikIslemTuru = storeIslem.find(islem => islem.id === islemId);
                            if (!tesvikIslemTuru.donemZorunlu) {
                                i++;
                                let data = {};
                                data.id = i;
                                data.baslatmaTarihi = dateData;
                                data.domain = domain;
                                //data.donem = treeDataDonemSource.find(donem => donem.id === donemId);
                                data.tesvikIslemTuru = tesvikIslemTuru;
                                data.sira = sira;
                                data.islemDurumu = 0;
                                array.push(data);
                            }
                        });
                    }
                    
                });
                setSgkIslemEkleDetay(array);
                 
            });
        
    }

    return (
        <div >
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <Box direction="row" width="100%" height={25}>
                        <Item ratio={3}>
                            <DropDownBox
                                position="left"
                                value={treeBoxValue}
                                valueExpr="id"
                                displayExpr="name"
                                placeholder="Firma Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataSource}
                                onValueChanged={syncTreeViewSelection}
                                contentRender={treeViewRender}
                            />
                        </Item>
                        <Item ratio={1}>
                            <DropDownBox
                                position="left"
                                value={treeBoxDonemValue}
                                valueExpr="id"
                                displayExpr="donem"
                                placeholder="Dönem Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataDonemSource}
                                onValueChanged={syncTreeViewDonemSelection}
                                contentRender={treeViewDonemRender}
                            />
                        </Item>

                    </Box>
                    <Box direction="row" width="100%" height={50}>
                        <Item ratio={3}>
                            <TagBox
                                //valueExpr="id"
                                value={valueIslem}
                                displayExpr="adi"
                                valueExpr="id"
                                showClearButton={true}
                                showSelectionControls={true}
                                dataSource={storeIslem}
                                onValueChanged={tagBox_itemSelectionChanged}
                                placeholder="İşlem Seçiniz" />
                        </Item>
                        <Item ratio={1}>
                            <DateBox
                                //defaultValue={new Date()}
                                value={dateData}
                                type="datetime"
                                placeholder="İşlem Zamanını Seçiniz"
                                displayFormat="yyyy-MM-dd HH:mm:ss"
                                showClearButton={true}
                                useMaskBehavior={true}
                                onValueChanged={onDateValueChanged}
                            />
                        </Item>

                    </Box>


                    <Button icon="plus" width={150} text="Ekle" type={'success'} style={{ fontSize: "15px" }}
                        onClick={ekle}></Button>

                </div>
            </div>
            <DataGrid
                className="sgkIslemEkleFormGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={dataSource}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    startEditAction="click"
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'domain.name'} width={450} caption={'Firma'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="donem.donem" width={80} caption={'Dönem'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="tesvikIslemTuru.adi" width={120} caption={'İşlem'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="baslatmaTarihi" width={120} caption={'Başlama Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true} allowEditing={false} />
                <Column dataField={'sira'} width={60} caption={'Sıra'} dataType="int" visible={true} allowEditing={true} />

            </DataGrid>

            <Button
                width={1000}
                text="Save"
                type="success"
                stylingMode="contained"
                visible={formYetki.ekle}
                onClick={kaydet}
            />
        </div>
    )
}

export default SgkIslemEkleForm;
